import { Button, CircularProgress, Divider, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import CenteredMessage from "../../../../components/CenteredMessage";
import request from "../../../../request";
import swal from 'sweetalert';
import withRouterParams from "../../../../withRouterParams";
import LabeledContainer from "../../../../components/LabeledContainer";
import { Add, Block, Build, Edit, MoreVert, Numbers, Refresh, Send } from "@mui/icons-material";
import PillLabel from "../../../../components/PillLabel";
import { DOCUMENT_NAME, LOAN_STATUS, USER_ROLE } from "../../../../../../shared/constants";
import { connect } from "react-redux";
import ApproveRejectModal from "./ApproveRejectModal";
import { formatMoney, hasIntersection, isGuest } from "../../../../../../shared/utils";
import ActivationModal from "./ActivationModal";
import RoundedIconButton from "../../../../components/RoundedIconButton";
import LabeledContainerProduct from "../../LabeledContainerProduct";
import EntityInfo from "../../EntityInfo";
import RecordPayment from "../../RecordPayment";
import Restructure from "./Restructure";
import { requestConfirmation } from "../../../../utils";
import LoanDetails from "../../../../components/LoanDetails";
import LoanPaymentsTable from "../../../../components/LoanPaymentsTable";
import { ConnectEntityToQuickbooks } from "../../../../components/ConnectEntityToQuickbooks";
import ConnectToQuickbooksButton from "../../../../components/ConnectToQuickbooksButton";
import Attachment from "../../../../components/Attachment";
import NavigationStateSaver from "../../../../components/NavigationStateSaver";
import Statistic from "./Statistic";
import Statement from "./Statement";
import NumberCard from '../../../../components/NumberCard';
import AdjustOwing from "./AdjustOwing";


class _Loan extends NavigationStateSaver {

   state = {
      loading: false,
      data: null,
      approveRejectModalStatus: null,
      activationModalOpen: false,
      paymentDialogOpen: false,
      restructureModelOpen: false,
      connectToQuickbooksModalOpen: false,
      backdatedPaymentModal: false,
      moreActionsMenuAnchor: null,
      adjustOwingDialogOpen: false,
   }

   openAdjustOwingDialog = () => {
      this.setState({ adjustOwingDialogOpen: true });
   }

   closeAdjustOwingDialog = (data) => {
      this.setState({ adjustOwingDialogOpen: false });
      if (data)
         this.setState({ data });
   }

   openMoreActionsMenu = (event) => {
      const moreActionsMenuAnchor = event.currentTarget;
      this.setState({ moreActionsMenuAnchor });
   }

   closeMoreActionsMenu = () => {
      this.setState({ moreActionsMenuAnchor: null });
   }

   openBackdatedPaymentModal = () => {
      this.setState({ backdatedPaymentModal: true });
   }

   closeBackdatedPaymentModal = data => {
      this.setState({ backdatedPaymentModal: false });
      if (data)
         this.setState({ data });
   }

   openConnectToQuickbooksModal = () => {
      this.setState({ connectToQuickbooksModalOpen: true });
   }

   closeConnectToQuickbooksModal = (data) => {
      this.setState({ connectToQuickbooksModalOpen: false });

      if (data) {
         this.setState({
            data: {
               ...this.state.data,
               ...data,
            }
         });
      }
   }

   openRestructureModal = () => {
      this.setState({ restructureModelOpen: true });
   }

   closeRestructureModal = (data) => {
      this.setState({ restructureModelOpen: false });
      if (data)
         this.setState({ data });
   }

   openPaymentDialog = () => {
      this.setState({ paymentDialogOpen: true });
   }

   closePaymentDialog = (data) => {
      this.setState({ paymentDialogOpen: false });
      if (data)
         this.fetchData();
   }

   openActivationModal = () => {
      this.setState({ activationModalOpen: true }); 
   }

   closeActivationModal = loan => {
      this.setState({ activationModalOpen: false });
      if (loan)
         this.setState({ data: loan });
   }

   openApproveRejectModal = status => {
      this.setState({ approveRejectModalStatus: status });
   }

   closeApproveRejectModal = (loan) => {
      const update = { approveRejectModalStatus: null };

      if (loan)
         update.data = loan;

      this.setState(update);
   }

   getLoanId() {
      return this.props.params.id;
   }

   getDefaultPaymentAmount() {
      const payments = this.state.data.payments.filter(p => !p.paid);
      return payments.toReversed()[0]?.amount || 0;
   }

   fetchData = async () => {

      try {

         this.setState({ loading: true });

         // send request
         const res = await request.get(`/api/general/loans/${this.getLoanId()}`);
         const data = res.data;

         this.setState({ data });
         
      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         this.setState({ loading: false });
      }

   }

   markAsDefaulted = async (repossess) => {

      // confirm
      const confirmed = await requestConfirmation(`Are you sure you want to mark loan #${this.state.data.loan_no} as defaulted?`);
      if (!confirmed)
         return;

      try {

         this.setState({ loading: true });

         // send request
         const res = await request.post(`/api/finance/loans/${this.getLoanId()}/default`, { repossess });
         const data = res.data;

         this.setState({ data });
         swal("Success", "Loan marked as defaulted", "success");

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         this.setState({ loading: false });
      }
   }

   sendPaymentLink = async () => {

      // check if email and phone are
      const { email, phone } = this.state.data.customer;

      if (!email && !phone) {
         swal("Error", "Customer does not have email or phone", "error");
         return;
      }

      // confirm
      const confirmed = await requestConfirmation(`Are you sure you want to send payment link to ${[ email, phone ].join(' and ')}?`);
      if (!confirmed)
         return;

      try {
         
         this.setState({ loading: true });

         // send request
         await request.post(`/api/credit/loans/${this.getLoanId()}/send-payment-link`);
         swal("Success", "Payment link sent successfully", "success");
      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         this.setState({ loading: false });
      }
   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.data)
         await this.fetchData();
   }

   render() {
      
      const { loading, data } = this.state;
      let jsx, mnuMoreActions, adjustOwingModal;

      if (loading) {
         jsx = <div className="h-full flex items-center justify-center">
            <CircularProgress />
         </div>
      } else if (!data) {
         jsx = <CenteredMessage message="No data" onRefresh={this.fetchData} />
      } else {

         const { roles } = this.props;
         const { loan_no, product, customer, principal, annual_rate, owing, unpaid_interest,  tenure, deposit, agent, status, notes, payments, created_at, issued_at } = data;

         const canApproveOrReject = hasIntersection(roles, [ USER_ROLE.SUPER_ADMIN, USER_ROLE.FINANCE_MANAGER ]) && status === LOAN_STATUS.PENDING;

         const isCreditManager = hasIntersection(roles, [ USER_ROLE.SUPER_ADMIN, USER_ROLE.CREDIT_MANAGER ]);
         const canActivate = isCreditManager && status === LOAN_STATUS.APPROVED;
         const canSendPaymentLink = isCreditManager && status === LOAN_STATUS.ACTIVE;

         const canRecordPayment = (isCreditManager && status === LOAN_STATUS.ACTIVE && owing > 0)
            && ![ LOAN_STATUS.PENDING, LOAN_STATUS.REJECTED ].includes(status);
            
         const canRestructure = hasIntersection(roles, [ USER_ROLE.SUPER_ADMIN, USER_ROLE.FINANCE_MANAGER ]) && status === LOAN_STATUS.ACTIVE;
         const canDefault = hasIntersection(roles, [ USER_ROLE.SUPER_ADMIN, USER_ROLE.FINANCE_MANAGER ]) && status === LOAN_STATUS.ACTIVE;
         const canUploadAttachments = hasIntersection(roles, [ USER_ROLE.SUPER_ADMIN, USER_ROLE.SALES_MANAGER ]);

         const attachments = [ ...customer.attachments, ...data.attachments ];

         const btnReject = <Button
            variant="outlined"
            size="small"
            className="px-4 rounded-full"
            disabled={!canApproveOrReject}
            onClick={() => this.openApproveRejectModal(LOAN_STATUS.REJECTED)}
         >
            REJECT
         </Button>

         const btnAccept = <Button
            variant="contained"
            color="primary"
            size="small"
            className="px-4 rounded-full"
            disabled={!canApproveOrReject}
            onClick={() => this.openApproveRejectModal(LOAN_STATUS.APPROVED)}
         > 
            APPROVE
         </Button>

         const btnActivate = <Button
            variant="contained"
            size="small"
            className="px-4 rounded-full"
            disabled={!canActivate}
            onClick={this.openActivationModal}
         >
            ACTIVATE
         </Button>

         const btnPay = <Button
            variant="contained" 
            size="small" 
            className="px-4 rounded-full" 
            onClick={() => this.openPaymentDialog()} 
            disabled={!canRecordPayment}
         >
            PAY
         </Button>

         const actionButtons = [];

         if (status === LOAN_STATUS.PENDING) {
            actionButtons.push(btnReject, btnAccept);
         } else if (status === LOAN_STATUS.APPROVED) {
            actionButtons.push(btnActivate);
         } else if (status === LOAN_STATUS.ACTIVE) {
            actionButtons.push(btnPay);
         }

         let actions;
         const { quickbooks_invoice_id } = data;

         const btnRefresh = <RoundedIconButton onClick={this.fetchData} color="secondary">
            <Refresh />
         </RoundedIconButton>

         if (status === LOAN_STATUS.ACTIVE && !quickbooks_invoice_id) {
            actions = <>
               <ConnectToQuickbooksButton onClick={this.openConnectToQuickbooksModal} />
               {btnRefresh}
            </>
         } else {
            actions = <>
               {actionButtons}
               {btnRefresh}
            </>
         }

         actions = <div className="flex items-center gap-4">
            <IconButton
               onClick={this.openMoreActionsMenu}
               className="bg-gray-50"
            >
               <MoreVert />
            </IconButton>
            {actions}
         </div>

         mnuMoreActions = this.state.moreActionsMenuAnchor && <Menu
            anchorEl={this.state.moreActionsMenuAnchor}
            onClose={this.closeMoreActionsMenu}
            anchorOrigin={{
               vertical: 'top',
               horizontal: 'left',
            }}
            transformOrigin={{
               vertical: 'bottom',
               horizontal: 'right',
            }}
            open
         >
            {
               [
                  {
                     icon: Send,
                     caption: 'Send payment link',
                     disabled: !canSendPaymentLink,
                     onClick: this.sendPaymentLink
                  },
                  { divider: true },
                  {
                     icon: Add,
                     caption: 'Backdated payment',
                     disabled: !canRecordPayment,
                     onClick: this.openBackdatedPaymentModal
                  },
                  {
                     icon: Build,
                     caption: 'Restructure loan',
                     disabled: !canRestructure,
                     onClick: this.openRestructureModal,
                  },
                  {
                     icon: Edit,
                     caption: 'Adjust owing',
                     disabled: status !== LOAN_STATUS.ACTIVE,
                     onClick: this.openAdjustOwingDialog,
                  },
                  { divider: true },
                  {
                     icon: Block,
                     caption: 'Default and repossess',
                     disabled: !canDefault,
                     onClick: () => this.markAsDefaulted(true),
                  },
                  {
                     icon: Block,
                     caption: 'Default (no repossession)',
                     disabled: !canDefault,
                     onClick: () => this.markAsDefaulted(false),
                  }
               ]
                  .map(item => {

                     if (item.divider)
                        return <Divider />

                     return <MenuItem
                        onClick={() => {
                           this.closeMoreActionsMenu();
                           item.onClick();
                        }}
                        disabled={item.disabled}
                     >
                        <ListItemIcon>
                           <item.icon fontSize="small" />
                        </ListItemIcon>
                        {item.caption}
                     </MenuItem>
                  })
            }
         </Menu>

         adjustOwingModal = this.state.adjustOwingDialogOpen && <AdjustOwing
            loanId={this.getLoanId()}
            owing={owing}
            unpaid_interest={unpaid_interest}
            onClose={this.closeAdjustOwingDialog}
         />

         jsx = <div className="h-full grid grid-rows-[1fr,auto]">
            <div className="py-4 overflow-auto">
               <div className="text-xl md:text-3xl text-gray-600 flex items-center">
                  Loan <span className="text-gray-500 ml-2">#{loan_no}</span>
                  <PillLabel color="secondary" className="ml-2">
                     {status.toUpperCase()}
                  </PillLabel>
               </div>

               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8">
                  <NumberCard
                     title="Owing"
                     value={formatMoney(owing)}
                     icon={<Numbers />}
                     className="bg-[#965A39] text-white"
                  />
                  <NumberCard
                     title="Unpaid principal"
                     value={formatMoney(owing - unpaid_interest)}
                     icon={<Numbers />}
                     className="bg-[#C05E2A] text-white"
                  />
                  <NumberCard
                     title="Unpaid interest"
                     value={formatMoney(unpaid_interest)}
                     icon={<Numbers />}
                     className="bg-[#6B4C3B] text-white"
                  />
               </div>

               <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-8">
                  {customer && !isGuest(roles) && <EntityInfo info={customer} title="Customer" />}
                  {product && <LabeledContainerProduct product={product} />}
                  <LoanDetails
                     principal={principal}
                     annual_rate={annual_rate}
                     tenure={tenure}
                     owing={owing}
                     deposit={deposit}
                     agent={isGuest(roles) ? null : agent}
                     created_at={created_at}
                     issued_at={issued_at}
                  />
                  {
                     ![ LOAN_STATUS.PENDING, LOAN_STATUS.APPROVED, LOAN_STATUS.REJECTED ].includes(status) && <Statistic { ...data } />
                  }
                  {
                     !isGuest(roles) && <LabeledContainer label="Attachments" className="rounded-lg p-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                           {
                              Object
                                 .values(DOCUMENT_NAME.LOAN)
                                 .map(name => {
                                    const attachment = attachments.find(a => a.name === name);
                                    return <div key={name}>
                                       <Attachment
                                          name={name}
                                          url={attachment?.url}
                                          canEdit={canUploadAttachments} // TODO: disable when attachment is already uploaded
                                          onSave={async data => {
                                             const res = await request.post(`/api/sales/loans/${this.getLoanId()}/attachments`, data);
                                             this.setState({ data: res.data });
                                          }}
                                       />
                                    </div>
                                 })
                           }
                        </div>
                     </LabeledContainer>
                  }
                  {
                     ![ LOAN_STATUS.PENDING, LOAN_STATUS.APPROVED, LOAN_STATUS.REJECTED ].includes(status) && <Statement
                        loan={data}
                     />
                  }
                  {
                     notes && <LabeledContainer label="Notes" className="rounded-lg p-4">
                        <div className="text-gray-600">
                           {notes}
                        </div>
                     </LabeledContainer>
                  }
                  {
                     payments.length > 0 && <div className="col-span-full">
                        <LoanPaymentsTable payments={payments} />
                     </div>
                  }
               </div>
            </div>
            <div className="flex items-center justify-end border-t border-gray-200 pt-4">
               {actions}
            </div>
         </div>
      }
      
      return <div className="h-full p-4">
         {jsx}
         {
            this.state.approveRejectModalStatus && <ApproveRejectModal
               loanId={this.getLoanId()}
               status={this.state.approveRejectModalStatus}
               onClose={this.closeApproveRejectModal}
            />
         }
         {
            this.state.activationModalOpen && <ActivationModal
               loanId={this.getLoanId()}
               onClose={this.closeActivationModal}
               depositAmount={data?.deposit}
            />
         }
         {
            this.state.paymentDialogOpen && <RecordPayment
               submit={
                  async data => {
                     const res = await request.post(`/api/credit/loans/${this.getLoanId()}/payments`, data);
                     return res.data;
                  }
               }
               amountField
               amount={this.getDefaultPaymentAmount()}
               title="Record Loan Payment"
               onClose={this.closePaymentDialog}
               bankAccountField
            />
         }
         {
            this.state.backdatedPaymentModal && <RecordPayment
               submit={
                  async data => {
                     const res = await request.post(`/api/credit/loans/${this.getLoanId()}/backdated-payments`, data);
                     return res.data;
                  }
               }
               paidAtField
               amountField
               title="Record Backdated Payment"
               onClose={this.closeBackdatedPaymentModal}
            />
         }
         {
            this.state.restructureModelOpen && <Restructure
               loan={data}
               onClose={this.closeRestructureModal}
            />
         }
         {
            this.state.connectToQuickbooksModalOpen && <ConnectEntityToQuickbooks
               quickbooksIdKey="quickbooks_invoice_id"
               submitUrl={"/api/general/quickbooks/invoice-connection"}
               fetchData={async () => {
                  const res = await request.get("/api/general/quickbooks/invoices");
                  return res.data.invoices;
               }}
               entityKey="loan"
               entityId={this.getLoanId()}
               renderOption={(props, option) => {
                  return <li {...props} className="border-b last:border-none cursor-pointer hover:bg-gray-100">
                     <div className="px-4 py-2">
                        <div className="font-bold text-gray-600">{option.name}</div>
                        <div className="text-gray-500 text-sm">
                           {formatMoney(option.amount)} | {formatMoney(option.balance)}
                        </div>
                     </div>
                  </li>
               }}
               onClose={this.closeConnectToQuickbooksModal}
            />
         }
         {mnuMoreActions}
         {adjustOwingModal}
      </div>
   }

}

const mapStateToProps = state => {
   return {
      roles: state?.user?.roles || []
   }
}

const Loan = connect(mapStateToProps)(withRouterParams(_Loan));

export default Loan;